import { ItemType } from "@/api";
import { useUser } from "@/providers/context";

import { CommentsInner } from "./CommentsInner";
import { CommentsProvider } from "./providers/CommentsProvider";

export interface CommentsProps {
  itemId: number;
  itemType: ItemType;
  sourceId: string;
  dataSource: string;
  liveEventStartDate?: string;
  liveEventEnded?: string;
  showHeader?: boolean;
}

export const Comments = (props: CommentsProps) => {
  const { user_name } = useUser();

  // If the user is not logged in, show nothing
  if (!user_name) {
    return null;
  }

  return (
    <CommentsProvider props={props}>
      <CommentsInner />
    </CommentsProvider>
  );
};
